import { Yup, type YupTypes, inputFileSchema } from "@pharmupp/p3-front-commons"
import type { NewsRubricsName } from "../../../commons"
import type { LabOrExternChoice } from "../../../core"
import { fields } from "../../components"

export const schema = Yup.object({
  publishLater: Yup.boolean(),
  publicationDate: Yup.date().when(
    fields.publishLater,
    ([publishLater]: boolean[], schemaRef) =>
      publishLater === true ? schemaRef.required() : schemaRef,
  ),
  rubric: Yup.string<NewsRubricsName>().required(),
  category: Yup.object({
    label: Yup.string().required(),
    code: Yup.string().required(),
  })
    .default(undefined)
    .notRequired()
    .when(fields.rubric, {
      is: (rubric: NewsRubricsName) => rubric === "UPP_GROUP",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema,
    }),
  labOrExtern: Yup.string<LabOrExternChoice>().when(fields.rubric, {
    is: (rubric: NewsRubricsName) => rubric === "LAB_EXTERN",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  laboratoryId: Yup.number().when([fields.rubric, "labOrExtern"], {
    is: (rubric: NewsRubricsName, labOrExtern: LabOrExternChoice) =>
      rubric === "LAB_EXTERN" && labOrExtern === "laboratory",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  solutionId: Yup.number().when([fields.rubric, "labOrExtern"], {
    is: (rubric: NewsRubricsName, labOrExtern: LabOrExternChoice) =>
      rubric === "LAB_EXTERN" && labOrExtern === "solution",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  title: Yup.string().max(100).required(),
  description: Yup.string().required(),
  image: inputFileSchema.default(undefined).notRequired(),
  isFlash: Yup.boolean().required(),
  restrictedUppIds: Yup.array().of(Yup.number().required()),
  diffusion: Yup.string().required(),
})

export type AdminNewsFormValues = YupTypes.InferType<typeof schema>
